import { createUserEventsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const UserEventsService = createUserEventsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
